<script>
  export let router = {}
  import Card from './profile/Card.svelte'
</script>

<style>

.divider {
  margin: 7rem 0; /* Space out the Bootstrap <hr> more */
}

h1 {
  font-weight: 800;
  margin-bottom: 2rem;
}

.asbody {
    background: #e8cbc0;
    background: -webkit-linear-gradient(to right, #e8cbc0, #636fa4);
    background: linear-gradient(to right, #e8cbc0, #636fa4);
    min-height: 96vh;
}
@media (min-width: 1200px) {
  .container {
    width: 760px;
  }
}
</style>

<div class="py-3 asbody">
    
    <div class="divider"/>

    <div class="container">
      <h1 class="text-left text-white h1">Meet the Team</h1>
    </div>
    

    <Card 
      name="Sylvia" 
      role="Founder" 
      bio="A Multi-lingual multi-tasker, Sylvia's legal qualifications and collections experience means she knows the process back-to-front."
      imgSrc="https://d19m59y37dris4.cloudfront.net/university/1-1-1/img/teacher-4.jpg"
    />

    <Card 
      name="Joseph" 
      role="Founder" 
      bio="Looking after the data and all the technical stuff, Joe's long career in IT makes him no stranger to billing cycles, spreadsheets and automation."
      imgSrc="https://d19m59y37dris4.cloudfront.net/university/1-1-1/img/teacher-2.jpg"
    />

    <Card 
      name="YOU!" 
      role="Our Esteemed Customer" 
      bio="You know your business, like we know ours. 
      Together, we make a great team!"
      imgSrc="https://d19m59y37dris4.cloudfront.net/university/1-1-1/img/teacher-1.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
    />

</div>